import React from "react";
import UtilizationModule from "./utilizationModule";
import UtilizationSagas from "./redux/sagas/utilization";
import UtilizationReducer from "./redux/reducers/utilization";
import PageWithConfigurator from "../../global/pageWithConfigurator/pageWithConfigurator";

const pageConfig = {
  pageName: "Utilization",
  moduleList: [
    {
      Component: UtilizationModule,
      moduleName: "utilization",
      saga: UtilizationSagas(),
      reducer: UtilizationReducer
    }
  ],
  hideConfigurator: true
};

const UtilizationPage = ({ notifications }) => {
  return <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />;
};

export default UtilizationPage;
